import request from "../utils/request";

export function getList(params = {}) {
  return request({
    url: "cong-tac",
    method: "get",
    params,
  });
}
